const Footer = () => {
  return (
    <footer>
     <a href="http://www.jordantwall.com"> Return to Portfolio</a>
    </footer>
  )
}

export default Footer